import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../utils/services/api.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent implements OnInit {
  // Define form fields using ngModel
  name: string = '';
  about_us: string = '';
  about_us_image: any = null;  // Image file data
  selectedFileName: string | ArrayBuffer | null = null;
  isSubmitting = false;
  isEdit = false;
  aboutUsId: any;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private toastr: ToastrService,
    private LoaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.LoaderService.showLoader();
    const data = localStorage.getItem('type');
    const state = history?.state;

    if (state?.from == 'edit' || data == 'edit') {
      this.isEdit = true;
      this.loadEditForm(state?.data);
    }

    this.LoaderService.hideLoader();
  }

  loadEditForm(formData: any) {
    this.LoaderService.showLoader();

    const jsonObject = JSON.parse(formData?.about_us_image);


    this.name = formData?.name;
    this.about_us = formData?.about_us;
    this.about_us_image = jsonObject;
    this.selectedFileName = jsonObject?.orgname;
    this.aboutUsId = formData._id;
    console.log(jsonObject);
    this.LoaderService.hideLoader();
  }

  // Handle file change event
  onFileChange(event: any): void {
    this.LoaderService.showLoader();
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      if (!file.type.startsWith('image/')) {
        console.error('Selected file is not an image.');
        this.about_us_image = null; 
        return;
      }
      const img = new Image();
      const reader = new FileReader();
  
      reader.onload = (e: any) => {
        img.src = e.target.result;
      };
  
      img.onload = () => {
        // if (img.width < 700 || img.height < 700) {
        //   console.error('Image dimensions are smaller than 700x700.');
        //   this.about_us_image = null;  
        //   this.LoaderService.hideLoader();
        //   Swal.fire({
        //     icon: 'error',
        //     title: 'Invalid file type',
        //     text: 'Please select a valid image file.',
        //   });
        //   return;
        // }
  
        this.selectedFileName = file.name;
        const form = new FormData();
        form.append('uploadFile', file);
  
        this.apiService.uploadFile(form).subscribe((res: any) => {
          console.log(res);
  
          this.about_us_image = res.file_data[0];
          if (this.about_us_image) {
            this.LoaderService.hideLoader();
          } else {
            this.LoaderService.hideLoader();
          }
        });
      };
      reader.readAsDataURL(file);
    }
  }
  

  // Form submission method
  editAboutUs(): void {
    // this.LoaderService.showLoader();
    console.log(this.about_us_image, "image");

    // Ensure you serialize about_us_image if it's an object
    const image = JSON.stringify(this.about_us_image);

    if (this.name && this.about_us && this.about_us_image) {
      const formData = new FormData();
      formData.append('name', this.name);
      formData.append('about_us', this.about_us);
      formData.append('about_us_image', image);

      console.log(formData);
      this.LoaderService.showLoader();

      this.apiService.editAbout(this.aboutUsId, formData).subscribe({
        next: (response) => {
          this.LoaderService.hideLoader();

          // SweetAlert2 Success Alert
          Swal.fire({
            title: 'Success!',
            text: response['message'], // Your success message from the API
            icon: 'success',
            confirmButtonText: 'OK'
          });

          this.router.navigate(['/about-us-list']);
        },
        error: (error) => {
          this.LoaderService.hideLoader();

          // SweetAlert2 Error Alert
          Swal.fire({
            title: 'Error!',
            text: error.error['message'], // Your error message from the API
            icon: 'error',
            confirmButtonText: 'OK'
          });
        }
      });
    } else {
      this.LoaderService.hideLoader();

      // SweetAlert2 Validation Error Alert
      Swal.fire({
        title: 'Form Invalid!',
        text: 'Please fill out all required fields.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });

      console.error('Form is invalid.');
    }
  }

}
